import { Pressable, View, ViewStyle } from "react-native";
import { Control, Controller } from "react-hook-form";
import { Text, Checkbox } from "react-native-paper";
import { JobApplyFormData } from "./types";
import { ErrorHelperText } from "../../components";
import { openBrowser } from "../utils";

interface TermsAndConditionsProps {
  control: Control<JobApplyFormData>;
  style?: ViewStyle;
}

const TermsAndConditions = ({ control, style }: TermsAndConditionsProps) => {
  return (
    <View {...{ style }} className="flex-row items-center px-6 py-8">
      <Controller
        key="terms"
        name="terms"
        control={control}
        rules={{ required: "you must accept the terms and conditions" }}
        defaultValue={false}
        render={({ field: { onChange, value }, fieldState: { error } }) => (
          <Pressable
            className="flex-row items-center"
            onPress={() => {
              onChange(!value);
            }}
          >
            <Checkbox.Android status={value ? "checked" : "unchecked"} testID="job-apply-terms" />
            <View className="flex-shrink">
              <Text className="text-regular-normal font-400 text-ink-dark ml-2 flex-shrink">
                I've read and accept the{" "}
                <Text
                  className="text-primary text-regular-normal font-400 underline"
                  onPress={openBrowser("https://www.pga.org/pga-employment-center-term-conditions")}
                >
                  terms & conditions
                </Text>
              </Text>
              {!!error?.message && <ErrorHelperText error={error}>{error?.message}</ErrorHelperText>}
            </View>
          </Pressable>
        )}
      />
    </View>
  );
};

export default TermsAndConditions;
